import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CalculateIcon from '@mui/icons-material/Calculate';
import PaymentsIcon from '@mui/icons-material/Payments';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
const CIRCLE_RED = "#FDE8E9";
const ICON_SX = {
    color: 'red',
};
const STAT_DETAILS = {
    "irr": {
        "icon": _jsx(TrendingUpIcon, { sx: ICON_SX }),
        "title": "Internal Rate of Return (IRR)"
    },
    "incrementalNpv": {
        "icon": _jsx(CalculateIcon, { sx: ICON_SX }),
        "title": "Incremental NPV"
    },
    "moic": {
        "icon": _jsx(PaymentsIcon, { sx: ICON_SX }),
        "title": "MOIC"
    },
    "fAndD": {
        "icon": _jsx(OilBarrelIcon, { sx: ICON_SX }),
        "title": "F&D ($/Boe)"
    },
    "refracCostEstimate": {
        "icon": _jsx(AccountBalanceWalletIcon, { sx: ICON_SX }),
        "title": "Re-frac Cost Estimate"
    }
};
const HeadlineStatCard = ({ statId, statValue }) => {
    const statCard = STAT_DETAILS[statId];
    return (_jsxs(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            flex: 1,
            gap: '5px',
            width: '100%',
        }, children: [_jsx(Box, { sx: {
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: CIRCLE_RED,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }, children: statCard.icon }), _jsx(Typography, { sx: {
                    fontSize: "14px",
                    fontWeight: 200,
                    lineHeight: "20.02px",
                    wordWrap: 'break-word',
                    color: '#8E8F96'
                }, children: statCard.title }), _jsx(Typography, { variant: "h4", children: statValue })] }, statId));
};
export default HeadlineStatCard;
